type ComputeZeroToMaxTupleHelper<
  TMax extends number,
  TResult extends [ ...number[] ] = [],
> =
  (TResult[ 'length' ] extends TMax
    ? TResult
    : ComputeZeroToMaxTupleHelper<TMax, [ ...TResult, TResult[ 'length' ] ]>
  );

type ComputeZeroToMaxTuple<TMax extends number> =
  number extends TMax
  ? never
  : (
    `${ TMax }` extends `-${ number }`
      ? never
      : ComputeZeroToMaxTupleHelper<TMax, []>
  );

export type NumbersFromZeroToMaxTuple<TMax extends number> = ComputeZeroToMaxTuple<TMax>;



type NumbersFromZeroToMaxHelper<
  TMax extends number,
  RangeTuple extends [ ...number[] ] = NumbersFromZeroToMaxTuple<TMax>,
  TKeys extends keyof RangeTuple = keyof RangeTuple
> = RangeTuple[ TKeys ];

export type NumbersFromZeroToMax<TMax extends number> = NumbersFromZeroToMaxHelper<TMax>;

export function numbersFromZeroToMaxTuple<TMax extends number> (maxNumber: TMax): NumbersFromZeroToMaxTuple<TMax> {
  if (maxNumber > 100) {
    throw new Error(`The parameter maxNumber cannot be over 100. Value is: ${maxNumber}`);
  }
  const numbersArr: number[] = [];
  for (let i = 0; i < maxNumber; i++){
    numbersArr.push(i);
  }
  return numbersArr as NumbersFromZeroToMaxTuple<TMax>;
}